import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SOLUTIONS } from "../../data/site";
import { Reveal, CropFrame } from "../motion";
import { SectionHead } from "../SectionHead";

const Row = ({ s, i }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ["0%", "0%"] : ["-8%", "8%"]);
  const flip = i % 2 === 1;
  return (
    <div ref={ref} data-testid={`solution-row-${i + 1}`} className="grid items-center gap-10 border-t border-[color:var(--ngp-line)] py-14 md:grid-cols-12 md:gap-12 lg:py-20">
      <div className={`md:col-span-6 ${flip ? "md:order-2 md:col-start-7" : ""}`}>
        <Reveal>
          <CropFrame className="mx-2">
            <div className="relative aspect-[4/3] overflow-hidden rounded-[var(--ngp-radius)] bg-[color:var(--ngp-ink)]">
              <motion.img style={{ y, scale: 1.18 }} src={s.img} alt={s.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
            </div>
          </CropFrame>
        </Reveal>
      </div>
      <div className={`md:col-span-5 ${flip ? "md:order-1 md:col-start-1" : "md:col-start-8"}`}>
        <Reveal>
          <p className="eyebrow text-[color:var(--ngp-teal-ink)]">{String(i + 1).padStart(2, "0")} — {s.eyebrow}</p>
          <h3 className="font-display mt-4 text-3xl font-semibold leading-[1.02] sm:text-4xl">{s.title}</h3>
        </Reveal>
        <ul className="mt-8 divide-y divide-[color:var(--ngp-line)] border-y border-[color:var(--ngp-line)]">
          {s.points.map((p, k) => (
            <Reveal as="li" key={p} delay={0.05 * k} y={12} className="flex items-center gap-4 py-3.5 text-base">
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[color:var(--ngp-teal)]" aria-hidden="true" />{p}
            </Reveal>
          ))}
        </ul>
        <Link to={s.to} data-testid={`solution-link-${i + 1}`} className="group mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--ngp-ink)]">
          <span className="link-underline">Approfondisci</span>
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
};

export const Solutions = () => (
  <section data-testid="solutions-section" className="bg-white">
    <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-36">
      <SectionHead index="02" eyebrow="Le nostre soluzioni" lines={["Tecnica, materiali,", "idee."]}
        text="Tutto quello che serve per portare il tuo marchio su carta, superfici, spazi ed eventi." />
      <div className="mt-14 lg:mt-20">
        {SOLUTIONS.map((s, i) => <Row key={s.eyebrow} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
